export function isLikelySwiftWooJwt(value: unknown): value is string {
  if (typeof value !== "string" || !value.trim()) {
    console.warn("[JWT] Failed: Not a string or empty");
    return false;
  }

  const token = value.trim();
  const parts = token.split(".");

  if (parts.length !== 3) {
    console.warn("[JWT] Failed: Does not have 3 parts");
    return false;
  }

  if (
    !parts.every((part) =>
      /^[A-Za-z0-9_-]+$/.test(part)
    )
  ) {
    console.warn("[JWT] Failed: Invalid Base64Url characters");
    return false;
  }

  try {
    const decodeBase64UrlJson = (part: string) => {
      const padded = part
        .replace(/-/g, "+")
        .replace(/_/g, "/")
        .padEnd(
          part.length + (4 - (part.length % 4)) % 4,
          "="
        );

      let decodedString = "";
      try {
        decodedString = atob(padded);
      } catch (e) {
        console.warn("[JWT] Failed: atob error on part", part);
        return null;
      }

      try {
        decodedString = decodeURIComponent(escape(decodedString));
      } catch (e) {}

      try {
        return JSON.parse(decodedString);
      } catch (e) {
        console.warn("[JWT] Failed: JSON.parse error on", decodedString);
        return null;
      }
    };

    const header = decodeBase64UrlJson(parts[0]);
    const payload = decodeBase64UrlJson(parts[1]);

    if (!header || typeof header !== "object") {
      console.warn("[JWT] Failed: Header is not a valid object");
      return false;
    }

    if (!payload || typeof payload !== "object") {
      console.warn("[JWT] Failed: Payload is not a valid object");
      return false;
    }

    if (payload.exp && Number(payload.exp) <= Date.now() / 1000) {
      console.warn("[JWT] Failed: Token is expired");
      return false;
    }

    return true;
  } catch (e) {
    console.warn("[JWT] Failed: Unexpected error", e);
    return false;
  }
}

export function getSwiftWooJwt(): string | null {
  const token = localStorage.getItem('swiftwoo_jwt_token');
  if (isLikelySwiftWooJwt(token)) {
    return token;
  }
  
  if (token) {
    console.warn("[JWT] Removing invalid token from localStorage");
    localStorage.removeItem('swiftwoo_jwt_token');
  }
  
  return null;
}
